import { render, staticRenderFns } from "./AnnouncementPagination.vue?vue&type=template&id=034202ca&scoped=true&"
import script from "./AnnouncementPagination.vue?vue&type=script&lang=js&"
export * from "./AnnouncementPagination.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementPagination.vue?vue&type=style&index=0&id=034202ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034202ca",
  null
  
)

export default component.exports